import { CarRentalOffer, RentalOption } from './CarOffer'
import { CarOfferRequest } from './OfferRequest'
import { DateOrNone, daysBucket } from '../analytics/Bucket'
import { HomerFetcher, fetcher } from '../api/fetcher'
import { CarRentalBooking } from './CarBooking'

/**
 * Get the base amount from an offer
 */
export function getBaseAmount(carOffer: CarRentalOffer | undefined): number {
  return carOffer ? parseInt(carOffer.base_amount || carOffer.net_rate) : -1
}

/**
 * Get the total amount, including one way fees, from an offer
 */
export function getTotalAmount(carOffer: CarRentalOffer | undefined) {
  return getBaseAmount(carOffer) + parseInt(carOffer?.one_way_fee || '0')
}

/**
 * Returns the daily amount according the number of days
 */
export function getDailyAmount(
  carOffer: CarRentalOffer,
  carOfferRequest: CarOfferRequest
) {
  return carOffer
    ? Math.ceil(
        getTotalAmount(carOffer) / carOfferRequest.number_of_days
      ).toFixed(0)
    : 0
}

/**
 * Get the number of days before a rental
 */
export function getDaysBeforeRental(date: DateOrNone, now = new Date()) {
  return daysBucket(date, now)
}

/**
 * Create a tracking context from a request
 */
export function trackingContextFromRequest(req: CarOfferRequest) {
  if (!req) {
    return {}
  }

  return {
    origin: req.origin.iata,
    destination: req.destination.iata,
    duration: daysBucket(req.return_date, req.pickup_date),
    days_before_rental: getDaysBeforeRental(req.pickup_date),
  }
}

export function trackingContextFromBooking(booking: CarRentalBooking) {
  if (!booking) {
    return {}
  }

  const ctxFromRequest = trackingContextFromRequest(booking.car_offer_request)

  return {
    ...ctxFromRequest,
    amount: booking.amount,
    value: Number.parseInt(booking.amount),
    revenue: Number.parseInt(booking.amount),
    currency: booking.currency,
  }
}

export function isPayableLater(option: RentalOption) {
  return option.type !== 'insurance'
}

/**
 * Filter options to be payed later
 */
export function getOptionsToPayLater(options: Array<RentalOption>) {
  return options.filter((o) => isPayableLater(o) && o.quantity > 0)
}

/**
 * Creates a car booking from the given car offer and offer request
 */
export const createCarBooking = (
  carOffer: CarRentalOffer,
  offerRequest: CarOfferRequest
) =>
  (fetcher as HomerFetcher<CarRentalBooking>)('/api/car_bookings', {
    api: process.env.NEXT_PUBLIC_LABS_API,
    method: 'POST',
    body: {
      car_booking: {
        car_offer: carOffer,
        car_offer_request: offerRequest,
        car_offer_options: carOffer.options,
        client_email: '',
        client_phone_number: '',
        driver_first_name: '',
        driver_last_name: '',
        provider: 'bsp_auto',
        provider_reference: '',
      },
    },
  })
